export const SET_CART_ITEMS_COUNT = 'shopcart/SET_CART_ITEMS_COUNT';
export const SET_CART = 'shopcart/SET_CART';
export const SET_SHOPCART_ERROR = 'shopcart/SET_SHOPCART_ERROR';
export const SET_VOUCHER_CODE_ERROR = 'shopcart/SET_VOUCHER_CODE_ERROR';
export const REMOVE_VOUCHER_CODE_ERROR = 'shopcart/REMOVE_VOUCHER_CODE_ERROR';
export const SET_GIFTCARD_CODE_ERROR = 'shopcart/SET_GIFTCARD_CODE_ERROR';
export const REMOVE_GIFTCARD_CODE_ERROR = 'shopcart/REMOVE_GIFTCARD_CODE_ERROR';
export const SET_IS_LOADED = 'shopcart/SET_IS_LOADED';
export const SET_IS_REQUEST_PENDING = 'shopcart/SET_IS_REQUEST_PENDING';
